import React, { useState } from 'react';
import PersonInputModal from './PersonInputModal';

const AddItem = ({ onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    woodType: '',
    length: '',
    depth: '',
    thickness: '',
    limit: '',
    amount: '',
    isHandRail: false,
    isOther: false
  });
  const [showPersonModal, setShowPersonModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowPersonModal(true); // Show the person input modal
  };

  const handlePersonConfirm = (name) => {
    onSubmit(formData, name); // Pass the person's name to onSubmit
    setShowPersonModal(false);
    onClose(); // Close the AddItem window after submission
  };

  const handlePersonCancel = () => {
    setShowPersonModal(false);
  };

  const handleCancel = () => {
    onClose(); // Close the AddItem window on cancel
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-window modal-window--narrow">
        <h2 className="modal-title">Lisää puutavara</h2>
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="modal-form__column">
            <label htmlFor="woodType-input">Puulaji:</label>
            <input
              type="text"
              name="woodType"
              value={formData.woodType}
              onChange={handleChange}
              required
              className="modal-input"
            />
            <label htmlFor="length-input">Pituus:</label>
            <input
              type="text"
              name="length"
              value={formData.length}
              onChange={handleChange}
              required
              className="modal-input"
            />
            <label htmlFor="depth-input">Leveys:</label>
            <input
              type="text"
              name="depth"
              value={formData.depth}
              onChange={handleChange}
              required
              className="modal-input"
            />
          </div>
          <div className="modal-form__column">
            <label htmlFor="thickness-input">Paksuus:</label>
            <input
              type="text"
              name="thickness"
              value={formData.thickness}
              onChange={handleChange}
              required
              className="modal-input"
            />
            <label htmlFor="limit-input">Varmuusraja:</label>
            <input
              type="text"
              name="limit"
              value={formData.limit}
              onChange={handleChange}
              required
              className="modal-input"
            />
            <label htmlFor="amount-input">Määrä:</label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              required
              className="modal-input"
            />
          </div>
          <div className="modal-form__actions modal-actions--center">
            <button type="button" onClick={handleCancel} className="btn btn-ghost">Peru</button>
            <button type="submit" className="btn btn-primary">Lisää tuote</button>
          </div>
        </form>
      </div>
      {showPersonModal && <PersonInputModal onConfirm={handlePersonConfirm} onCancel={handlePersonCancel} />}
    </div>
  );


};

export default AddItem;